import { stripNonNumeric } from '@lbcamden/shared-utils';

export const pageTitle = (name = '') => `${name}${name ? ' - ' : ''}Camden Home Visits Application`;

export const sanitiseNumberString = (value: string) => stripNonNumeric(value, false);
